import { tabs } from 'data/constants';
import { ActiveTabType } from 'data/types';

export type VisibleTabsParams = {
  showExistingEquipmentTab: boolean;
  showEquipmentPreferencesTab: boolean;
  systemDesignLocked: boolean;
};

export const getVisibleTabs = ({
  showExistingEquipmentTab,
  showEquipmentPreferencesTab,
  systemDesignLocked
}: VisibleTabsParams): ActiveTabType[] =>
  tabs.filter((tab) => {
    if (tab === 'existingEquipment') return showExistingEquipmentTab;
    if (tab === 'equipmentPreferences') return showEquipmentPreferencesTab;
    if (tab === 'configurations') return !systemDesignLocked;
    return true;
  });

export const getVisibleTabIndex = (
  visibleTabs: ReadonlyArray<ActiveTabType>,
  activeTab: ActiveTabType
): number => Math.max(0, visibleTabs.indexOf(activeTab));
